import { useMemo } from 'react';
import { IContentTypeConditions } from '../components/types';
import { ADMIN_WIDGETS, ADMIN_WIDGETS_NAMES } from 'src/constants/widgets';
import { WIDGET_TYPE } from '../constant';

export function useGetContentTypeConditions({ listPresentationConfig }) {
  const contentType = listPresentationConfig?.contentItems?.type;

  const contentTypeConditions = useMemo<IContentTypeConditions>(() => {
    return {
      collection: contentType === WIDGET_TYPE.COLLECTION,
      category: [WIDGET_TYPE.CATEGORY, WIDGET_TYPE.CATEGORIES].includes(contentType),
      featured: contentType?.toLocaleLowerCase()?.includes?.(WIDGET_TYPE.FEATURE),
      featuredCollection: contentType?.includes?.(WIDGET_TYPE.FEATURED_COLLECTION),
      featuredReels: contentType?.includes?.(WIDGET_TYPE.FEATURED_REELS),
      testimonials: contentType?.includes?.(WIDGET_TYPE.TESTIMONIALS),
      logoSlider: listPresentationConfig?.type === WIDGET_TYPE.LOGO_SLIDER,
      blogs: listPresentationConfig?.type === WIDGET_TYPE.BLOG,
      featuredTag: contentType?.includes?.('featuredTag'),
      featuredCategory: contentType?.includes?.(ADMIN_WIDGETS.FEATURED_CATEGORIES.type),
      multiColumn:
        listPresentationConfig?.type === WIDGET_TYPE.ICON ||
        listPresentationConfig?.type === WIDGET_TYPE.IMAGE,
      multiColumnForIcon: listPresentationConfig?.type === WIDGET_TYPE.ICON,
      multiColumnForImage: listPresentationConfig?.type === WIDGET_TYPE.IMAGE,
      gallery: listPresentationConfig?.type === ADMIN_WIDGETS_NAMES.GALLERY,
      productTestimonial: listPresentationConfig?.type === ADMIN_WIDGETS_NAMES.PRODUCT_TESTIMONIAL,
      instagram: listPresentationConfig?.type === WIDGET_TYPE.INSTAGRAM
    };
  }, [contentType, listPresentationConfig?.type]);

  return { contentTypeConditions };
}
